import React from 'react';

const IconCategoryMultiday = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#fff" fillOpacity="0.5" rx="8"></rect>
      <rect
        width="31.5"
        height="31.5"
        x="0.25"
        y="0.25"
        stroke="#fff"
        strokeOpacity="0.5"
        strokeWidth="0.5"
        rx="7.75"
      ></rect>
      <path
        fill="#19191A"
        d="M23.382 10.23h-.43c-.768-8.624-12.963-8.617-13.727 0h-.43A2.297 2.297 0 0 0 6.5 12.524v11.47a2.297 2.297 0 0 0 2.294 2.295h14.588a2.297 2.297 0 0 0 2.294-2.294v-11.47a2.297 2.297 0 0 0-2.294-2.295m-7.294-5.735a6.125 6.125 0 0 1 6.118 6.117c-.336 8.116-11.9 8.114-12.235 0a6.125 6.125 0 0 1 6.117-6.117m8.824 19.5c0 .843-.686 1.53-1.53 1.53H8.794c-.843 0-1.53-.687-1.53-1.53v-11.47c0-.844.687-1.53 1.53-1.53h.431c.767 8.623 12.962 8.617 13.726 0h.431c.844 0 1.53.686 1.53 1.53z"
      ></path>
      <path
        fill="#19191A"
        d="M13.654 12.77a.38.38 0 0 0 .278.278l5.506 1.377c.267.075.54-.195.463-.464l-1.376-5.506a.38.38 0 0 0-.278-.278L12.74 6.8a.384.384 0 0 0-.464.464zm4.185-3.907 1.166 4.665-4.666-1.166-1.166-4.665zM23.86 17.85h-1.73a.694.694 0 0 0-.691.695v3.19q-.14.048-.258.134l-1.447-1.005-1.447-1.005c.194-.646-.328-1.325-.997-1.314-.662-.01-1.18.653-1.003 1.295l-2.527 1.694c-.6-.492-1.584-.062-1.644.712l-2.597.602c-.533-.868-1.918-.475-1.91.559.027 1.301 1.894 1.405 2.063.119l2.597-.602c.624.981 2.16.33 1.875-.812l2.527-1.695c.334.272.883.279 1.223.013l2.894 2.01c-.195.645.327 1.325.997 1.314 1.16-.01 1.427-1.631.345-2.02v-1.106h1.73a.694.694 0 0 0 .69-.694v-1.39a.694.694 0 0 0-.69-.694M8.646 23.754c-.455-.008-.455-.686 0-.695.454.009.454.687 0 .695m4.494-1.042c-.454-.008-.454-.686 0-.694.455.008.454.686 0 .694m4.15-2.778c-.455-.008-.455-.687 0-.695.453.008.453.687 0 .695m4.494 3.125c-.455-.008-.455-.686 0-.694.454.008.454.687 0 .695m.345-3.125v-1.39h1.73v1.39z"
      ></path>
    </svg>
  );
};

export default IconCategoryMultiday;
